import React from "react";
import { RouteComponentProps } from "react-router";
import { EmployeeGroupList } from '../components/employeeGroups/EmployeeGroupList';

export function EmployeeGroupListView({ match }: RouteComponentProps<{ id: string }>) {
    return (
        <div className="view view-employee-group-list-view">
            <EmployeeGroupList />
        </div>
    );
}
